import {
  Box,
  Button,
  Flex,
  LinkButton,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  Stack,
  Text,
  useColorMode,
} from '@tonic-one/react';
import { useNavigateWithHandler } from '@Utils/hooks';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const SecurityRiskEmailBannerPreview = (props: {
  onClose: () => void;
}) => {
  const { onClose } = props;
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const navigate = useNavigateWithHandler();

  const handleNavigateEmailReporting = useCallback(() => {
    const path = `/administrator/email-reporting`;
    navigate(path);
  }, [navigate]);

  return (
    <ModalContent width={550}>
      <ModalHeader>{t('policy.emailBanner.preview')}</ModalHeader>
      <ModalBody>
        <Stack gap="4x">
          <Text>{t('policy.emailBanner.preview.desc')}</Text>
          <Text>
            {t('policy.emailBanner.preview.disableGoTo')}{' '}
            <LinkButton
              display="inline-block"
              onClick={handleNavigateEmailReporting}
            >
              {t('administration.title')}
              {' > '}
              {t('administration.addIn.emailReporting.title')}
            </LinkButton>
          </Text>
          <Box
            borderWidth={0}
            borderLeftWidth={4}
            borderStyle="solid"
            borderColor="#C42B1C"
            width="100%"
            padding="4x"
            background={colorMode === 'light' ? '#FBF2F4' : '#332d2e'}
          >
            <Stack gap="2x">
              <Text fontWeight={600}>{t('policy.actionData.phishing')}</Text>
              <Text>{t('common.timeRange.from')}: (abc@outloOk.com)</Text>
              <Text fontWeight={600}>
                {t('policy.emailBanner.phishing.ruleName')}
              </Text>
              <Text>{t('policy.emailBanner.phishing.ruleDesc')}</Text>
              <Flex columnGap="2x">
                <Button variant="secondary" pointerEvents="none">
                  {t('policy.emailBanner.reportNotRisk')}
                </Button>
              </Flex>
            </Stack>
          </Box>
          <Box
            borderWidth={0}
            borderLeftWidth={4}
            borderStyle="solid"
            borderColor="#FABA2A"
            width="100%"
            padding="4x"
            background={colorMode === 'light' ? '#FFFCF1' : '#2d2b23'}
          >
            <Stack gap="2x">
              <Text fontWeight={600}>{t('policy.actionData.spam')}</Text>
              <Text>{t('common.timeRange.from')}: (events@e.segment.com)</Text>
              <Text fontWeight={600}>
                {t('policy.emailBanner.spam.ruleName')}
              </Text>
              <Text>{t('policy.emailBanner.spam.ruleDesc')}</Text>
              <Flex columnGap="2x">
                <Button variant="secondary" pointerEvents="none">
                  {t('policy.emailBanner.reportNotRisk')}
                </Button>
              </Flex>
            </Stack>
          </Box>
        </Stack>
      </ModalBody>
      <ModalCloseButton onClick={onClose} />
    </ModalContent>
  );
};

export const AnomalyEmailBannerPreview = (props: { onClose: () => void }) => {
  const { onClose } = props;
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const navigate = useNavigateWithHandler();

  const handleNavigateEmailReporting = useCallback(() => {
    const path = `/administrator/email-reporting`;
    navigate(path);
  }, [navigate]);

  return (
    <ModalContent width={550}>
      <ModalHeader>{t('policy.emailBanner.preview')}</ModalHeader>
      <ModalBody>
        <Stack gap="4x">
          <Text>{t('policy.emailBanner.preview.desc')}</Text>
          <Text>
            {t('policy.emailBanner.preview.disableGoTo')}{' '}
            <LinkButton
              display="inline-block"
              onClick={handleNavigateEmailReporting}
            >
              {t('administration.title')}
              {' > '}
              {t('administration.addIn.emailReporting.title')}
            </LinkButton>
          </Text>
          <Box
            borderWidth={0}
            borderLeftWidth={4}
            borderStyle="solid"
            borderColor="#C42B1C"
            width="100%"
            padding="4x"
            background={colorMode === 'light' ? '#FDF2F4' : '#332d2e'}
          >
            <Stack gap="2x">
              <Text fontWeight={600}>
                {t('policy.emailBanner.suspicious.title')}
              </Text>
              <Text>
                {t('common.timeRange.from')}: (no-reply@trendmicr0.com)
              </Text>
              <Text fontWeight={600}>
                {t('policy.emailBanner.suspicious.ruleName')}
              </Text>
              <Text>{t('policy.emailBanner.suspicious.ruleDesc')}</Text>
              <Flex columnGap="2x">
                <Button variant="secondary" pointerEvents="none">
                  {t('policy.emailBanner.suspicious.markSafe')}
                </Button>
                <Button variant="secondary" pointerEvents="none">
                  {t('policy.emailBanner.suspicious.reportPhishing')}
                </Button>
              </Flex>
            </Stack>
          </Box>
          <Box
            borderWidth={0}
            borderLeftWidth={4}
            borderStyle="solid"
            borderColor="#FABA2A"
            width="100%"
            padding="4x"
            background={colorMode === 'light' ? '#FFFCF1' : '#2d2b23'}
          >
            <Stack gap="2x">
              <Text fontWeight={600}>
                {t('policy.emailBanner.unwanted.title')}
              </Text>
              <Text>
                {t('common.timeRange.from')}: (no-reply@trendmicr0.com)
              </Text>
              <Text fontWeight={600}>
                {t('policy.emailBanner.unwanted.ruleName')}
              </Text>
              <Text>{t('policy.emailBanner.unwanted.ruleDesc')}</Text>
              <Flex columnGap="2x">
                <Button variant="secondary" pointerEvents="none">
                  {t('policy.emailBanner.unwanted.markWanted')}
                </Button>
                <Button variant="secondary" pointerEvents="none">
                  {t('policy.emailBanner.unwanted.reportSpam')}
                </Button>
              </Flex>
            </Stack>
          </Box>
        </Stack>
      </ModalBody>
      <ModalCloseButton onClick={onClose} />
    </ModalContent>
  );
};
